import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';

const Podcast = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('all');
  const [loading, setLoading] = useState(true);

  // Real program samples based on kiooradio.org/programs - Updated Dec 2025
  const programSamples = [
    // TOP PRIORITY - Featured French Programs - Renaissance First
    {
      id: 1,
      title: "Renaissance",
      language: "fr",
      description: "Weekly French interactive program featuring community discussions, cultural content, and inspirational messages. Hosted by Isabelle Kenne - 'La musique qui relève et restaure'",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-mobiscan/artifacts/omjpgxmv_Renaissance.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_kioo-mobiscan/artifacts/jnm1dsgz_JIngle%20Intro%20%20Rennaissance%20Kioo_mix%202.mp3",
      duration: "60:00",
      category: "Interactive",
      timeSlot: "Friday 16:00-17:00",
      frequency: "Weekly"
    },
    {
      id: 2,
      title: "La Vie Chez Nous",
      language: "fr",
      description: "Interactive French program discussing community life and local issues. Hosted by Benjamin Holl every Sunday at 2 PM GMT.",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-mobiscan/artifacts/9t3mlq56_La%20Vie%20Chez%20Nous.jpeg?v=20260211",
      audioUrl: "https://customer-assets.emergentagent.com/job_radio-weather-hub/artifacts/hmq9da5g_Spot%20Kioo%20Radio%2BLa%20Vie%20chez%20Nous_mixage%20final.mp3",
      duration: "2:45",
      category: "Interactive",
      timeSlot: "Sunday 14:00-15:00",
      frequency: "Weekly"
    },
    {
      id: 2,
      title: "Share Life Africa",
      language: "fr",
      description: "1-minute daily devotional program sharing life experiences and spiritual insights across Africa",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/04r4spr2_ShareLifeAfrica.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/yg9i77dh_33evan5-07f-2025.mp3",
      duration: "1:00",
      category: "Dévotion",
      timeSlot: "Daily 04:55 & 03:55",
      frequency: "Daily (7 days)"
    },
    {
      id: 3,
      title: "Mission Afrique Pour Christ",
      language: "fr",
      description: "15-minute French missions program focusing on Christian outreach across Africa, broadcast weekly",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/j30cli28_Mission%20Afrique%20Pour%20Christ.jpg",
      audioUrl: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/ceyf3700_33MISS7%201.mp3",
      duration: "15:00",
      category: "Missions",
      timeSlot: "Friday 09:45-10:00",
      frequency: "Weekly"
    },
    
    // Other programs with real audio files
    {
      id: 4,
      title: "Reset with Bonnie Sala",
      language: "en",
      description: "2-minute daily inspirational program with Bonnie Sala offering spiritual reset and encouragement for daily living",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/7ptge9rf_reset.jpg",
      audioUrl: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/2efho8o6_ENG_RBS_2025-01-01.mp3",
      duration: "2:00",
      category: "Devotional",
      timeSlot: "22:00-22:02",
      frequency: "Daily (Weekdays)"
    },
    {
      id: 5,
      title: "Guidelines for Living",
      language: "en",
      description: "Daily inspirational program offering practical guidance for Christian living and spiritual growth",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/879clz2x_guidelines%20.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/g77na89f_ENG_GDL_2025-01-01.mp3",
      duration: "5:10",
      category: "Bible Teaching",
      timeSlot: "15:30-15:35",
      frequency: "Daily (Weekdays)"
    },
    {
      id: 6,
      title: "Malaika",
      language: "fr",
      description: "30-minute French magazine program featuring cultural content and community stories, broadcast weekly",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/2w6jrb37_Malaika.jpg",
      audioUrl: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/hxzwhxxn_33MALA%201.mp3",
      duration: "30:00",
      category: "Magazine",
      timeSlot: "Monday 17:00-17:30",
      frequency: "Weekly"
    },
    {
      id: 7,
      title: "Focus Famille",
      language: "fr",
      description: "1-minute daily program focusing on family values, relationships, and Christian family principles",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/k0kuaw9w_Focus%20Famille.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/qofzesh9_33FOCU-144.mp3",
      duration: "1:00",
      category: "Famille",
      timeSlot: "Daily 04:25 & 03:25",
      frequency: "Daily (7 days)"
    },
    
    // Programs with placeholder audio files - LOWER PRIORITY
    {
      id: 7,
      title: "Love & Faith",
      language: "en",
      description: "Inspirational messages about love, faith, and Christian relationships",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-broadcast-mgmt/artifacts/e8t1xv32_Love-and-Faith.jpg",
      audioUrl: "/assets/audio/love-faith-sample.mp3",
      duration: "7:30",
      category: "Bible Teaching",
      timeSlot: "11:30-12:00"
    },
    {
      id: 8,
      title: "Thru the Bible (TTB) - Kissi",
      language: "kissi",
      description: "Bible teaching program in Kissi language, providing verse-by-verse study of Scripture",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-broadcast-mgmt/artifacts/bh1ilom6_Telling-the-vision-of-Kioo.jpg",
      audioUrl: "/assets/audio/ttb-kissi-sample.mp3",
      duration: "8:30",
      category: "Bible Teaching",
      timeSlot: "20:00-20:30"
    },
    {
      id: 11,
      title: "Thru the Bible (TTB) - English",
      language: "en",
      description: "English Bible teaching program offering comprehensive Scripture study",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-broadcast-mgmt/artifacts/bh1ilom6_Telling-the-vision-of-Kioo.jpg",
      audioUrl: "/assets/audio/ttb-english-sample.mp3",
      duration: "30:00",
      category: "Bible Teaching",
      timeSlot: "06:00-06:30"
    },
    {
      id: 12,
      title: "Pastor's Corner - Sierra Leone",
      language: "en",
      description: "Weekly sermons and teachings from pastors in Sierra Leone",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-broadcast-mgmt/artifacts/6f4q1xma_Praying-over-Gue%CC%81cke%CC%81dou.JPG",
      audioUrl: "/assets/audio/pastors-corner-sl-sample.mp3",
      duration: "14:30",
      category: "Sermon",
      timeSlot: "14:30-15:00"
    },
    {
      id: 13,
      title: "Community Announcements - Mixed",
      language: "mixed",
      description: "Important community announcements and public service messages in multiple languages",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-broadcast-mgmt/artifacts/dd62t4s1_view-of-Gue%CC%81cke%CC%81dou.jpg",
      audioUrl: "/assets/audio/community-mixed-sample.mp3",
      duration: "1:00",
      category: "Community",
      timeSlot: "Various times"
    },
    {
      id: 14,
      title: "VNA French Satellite Feed",
      language: "fr",
      description: "International French programming via satellite providing diverse content from Voice of America",
      thumbnail: "https://customer-assets.emergentagent.com/job_multilingual-radio/artifacts/msx2mv7v_Logo%20-%20YNOP%20-%20NLAN.png",
      audioUrl: "/assets/audio/vna-french-sample.mp3",
      duration: "10:00",
      category: "Satellite",
      timeSlot: "09:00-10:00"
    },
    {
      id: 15,
      title: "Worship & Music",
      language: "mixed",
      description: "Contemporary Christian worship music and traditional hymns in various languages",
      thumbnail: "https://customer-assets.emergentagent.com/job_kioo-broadcast-mgmt/artifacts/cc64kw9v_worship-music.jpg",
      audioUrl: "/assets/audio/worship-sample.mp3",
      duration: "4:00",
      category: "Worship",
      timeSlot: "Various times"
    }
  ];

  useEffect(() => {
    // Simulate loading
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const getLanguageLabel = (lang) => {
    const labels = {
      'kissi': 'Kissi',
      'en': 'English',
      'fr': 'French',
      'mixed': 'Mixed',
      'mandingo': 'Mandingo',
      'fula': 'Fula',
      'gbandi': 'Gbandi'
    };
    return labels[lang] || lang;
  };

  const getLanguageColor = (lang) => {
    const colors = {
      'kissi': 'bg-blue-100 text-blue-800',
      'en': 'bg-green-100 text-green-800',
      'fr': 'bg-purple-100 text-purple-800',
      'mixed': 'bg-orange-100 text-orange-800',
      'mandingo': 'bg-red-100 text-red-800',
      'fula': 'bg-yellow-100 text-yellow-800',
      'gbandi': 'bg-pink-100 text-pink-800'
    };
    return colors[lang] || 'bg-gray-100 text-gray-800';
  };

  const filteredSamples = selectedLanguage === 'all' 
    ? programSamples 
    : programSamples.filter(sample => sample.language === selectedLanguage);

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead 
        title="Program Samples - Kioo Radio"
        description="Listen to sample clips from Kioo Radio's inspiring programs in multiple languages. Experience our faith-based content serving the Makona River Region."
      />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-kioo-primary to-green-600 text-white">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Program Samples
            </h1>
            <p className="text-xl md:text-2xl mb-6 opacity-90">
              Listen & Experience Our Content
            </p>
            <p className="text-lg opacity-80 max-w-3xl mx-auto">
              Discover the inspiring content we broadcast daily. Listen to sample clips from our various programs 
              in multiple languages, bringing hope, faith, and community to the Makona River Region.
            </p>
          </div>
        </div>
      </div>

      {/* Language Filter */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex flex-wrap items-center justify-center gap-3">
            <span className="text-sm font-medium text-gray-700">Filter by Language:</span>
            {['all', 'kissi', 'en', 'fr', 'mixed', 'mandingo', 'fula'].map(lang => (
              <button
                key={lang}
                onClick={() => setSelectedLanguage(lang)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  selectedLanguage === lang
                    ? 'bg-kioo-primary text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {lang === 'all' ? '🌍 All Languages' : `${getLanguageLabel(lang)}`}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-kioo-primary mb-4"></div>
            <p className="text-gray-600">Loading program samples...</p>
          </div>
        ) : (
          <>
            {/* Results Count */}
            <div className="mb-6">
              <p className="text-gray-600">
                {filteredSamples.length} program sample{filteredSamples.length !== 1 ? 's' : ''} found
                {selectedLanguage !== 'all' && ` in ${getLanguageLabel(selectedLanguage)}`}
              </p>
            </div>

            {/* Program Samples Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredSamples.map((sample) => (
                <div key={sample.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
                  {/* Thumbnail */}
                  <div className="relative">
                    <img 
                      src={sample.thumbnail || '/assets/images/kioo-logo.png'}
                      alt={sample.title}
                      className={`w-full h-48 ${
                        ['Mission Afrique Pour Christ', 'Focus Famille', 'VNA French Satellite Feed', 'Reset with Bonnie Sala', 'Guidelines for Living', 'La Vie Chez Nous'].includes(sample.title) 
                          ? 'object-contain bg-gray-50' 
                          : 'object-cover'
                      }`}
                      onError={(e) => {
                        e.target.src = '/assets/images/kioo-logo.png';
                      }}
                    />
                    <div className="absolute top-3 left-3">
                      <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getLanguageColor(sample.language)}`}>
                        {getLanguageLabel(sample.language)}
                      </span>
                    </div>
                    <div className="absolute top-3 right-3 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
                      {sample.duration}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <div className="mb-3">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        {sample.title}
                      </h3>
                      <p className="text-sm text-kioo-primary font-medium">
                        {sample.category}
                      </p>
                    </div>
                    
                    <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                      {sample.description}
                    </p>

                    {/* Time Slot Info */}
                    <div className="mb-3">
                      <p className="text-xs text-gray-500">
                        📅 Air Time: {sample.timeSlot}
                      </p>
                      {sample.frequency && (
                        <p className="text-xs text-green-600 font-medium">
                          🔄 {sample.frequency}
                        </p>
                      )}
                    </div>

                    {/* Sample Audio Player */}
                    <div className="mb-4">
                      <audio 
                        controls 
                        preload="none"
                        className="w-full h-8"
                        style={{ height: '32px' }}
                      >
                        <source src={sample.audioUrl} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-2">
                      <button
                        onClick={() => {
                          // Share functionality
                          if (navigator.share) {
                            navigator.share({
                              title: sample.title,
                              text: sample.description,
                              url: window.location.href
                            });
                          } else {
                            navigator.clipboard.writeText(window.location.href);
                            alert('Link copied to clipboard!');
                          }
                        }}
                        className="px-3 py-2 border border-gray-300 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors"
                      >
                        📤 Share
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredSamples.length === 0 && (
              <div className="text-center py-12">
                <div className="text-gray-400 text-6xl mb-4">🎙️</div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">No samples found</h3>
                <p className="text-gray-600">
                  No program samples available for the selected language.
                </p>
              </div>
            )}
          </>
        )}
      </div>

      {/* Call to Action */}
      <div className="bg-kioo-primary text-white">
        <div className="max-w-4xl mx-auto px-4 py-12 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Ready to Listen Live?
          </h2>
          <p className="text-lg mb-6 opacity-90">
            Experience our full programming live on Kioo Radio 98.1 FM
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/listen-live"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-kioo-primary rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              📻 Listen Live Now
            </a>
            <a
              href="/programs"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-kioo-primary transition-colors"
            >
              📅 View Program Schedule
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Podcast;